
import { State } from 'vuex-class';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component({})
export default class TextFilter extends Vue {
    @Prop({ default: '' })
    value: string;
    @Prop({ default: '' })
    placeholder: string;
    @Prop({ default: '' })
    label: string;
    private inputText: string = '';

    created() {
        if (this.value) {
            this.inputText = this.value;
        }
    }

    @Watch('value')
    private onValueUpdate(newValue: string) {
        this.inputText = newValue;
    }

    @Watch('inputText')
    private handleInputChange(newValue: string) {
        this.$emit('update', this.inputText);
    }
}
